




























import Vue from "vue";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ProductQr",
  data() {
    return {
      fliterNumber: null,
      fliterDebounce: null,
      searchDebounce: null,
      textSearch: ""
    };
  },
  components: {
    ProductQrList: () => import("./productQrList.vue")
  },

  methods: {
    ...mapActions({
      fliterProduct: "productQr/filter",
      search: "productQr/search",
      getProcudtQr: "productQr/filter"
    }),
    ...mapMutations({
      setQuery: "productQr/setQuery"
    }),
    handleSearch() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.search(this.textSearch);
      }, 500);
    },
    handleFilter(value: string) {
      const code = this.$route.params.id;
      if (value == "ALL") {
        this.fliterProduct({ productCode: code, status: undefined });
      }
      if (value == "DONE") {
        this.fliterProduct({ productCode: code, statusBonusPoint: "DONE" });
      }
      if (value == "NONE") {
        this.fliterProduct({ productCode: code, statusBonusPoint: "NONE" });
      }
    }
  },
  created() {
    const code = this.$route.params.id;
    this.getProcudtQr({ productCode: code });
  }
});
